import { ModuleType } from '../../types/module';

export enum RequestTypeEnum {
	ENHANCEMENT = 'enhancement',
	BUG = 'bug',
	PURCHASE_SIGNATURE_INVITATIONS = 'purchase-signature-invitations',
}

export type SupportFormType = {
	type: RequestTypeEnum | null;
	module: Pick<ModuleType, 'code' | 'name'>;
	message: string | null;
	images?: File[];
};
